export default __webpack_public_path__ + "static/media/fitel.de7df4bf.jpg";